import { EMPLOYEE_LIST_FAIL, EMPLOYEE_LIST_REQUEST, EMPLOYEE_LIST_SUCCESS } from "../constats/employee.constant";

export const employeeListReducer = (state={},action) => {
    switch (action.type) {
        case EMPLOYEE_LIST_REQUEST:
            return {
                loading: true
            };
        case EMPLOYEE_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            }
        case EMPLOYEE_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            }
        default:
            return state;
    }
} 